// extracted by mini-css-extract-plugin
export default {"image":"jX-z","loaded":"kX-z"};